import React from 'react';
import Tooltip from '../../../Tooltip';
import Toggle from '../../../Toggle';
import { CASH, FINANCE } from '../../../../services/filters/filters';
import useTranslations from '@hooks/useTranslations';
import { TBudgetType } from '../../../../services/core/sdk/constants/sdkFields';

interface FinanceToggleProps {
    hasMonthlyPrices: boolean;
    budget: TBudgetType;
    changeBudgetType: (option: string) => void;
}

const FinanceToggle = ({ budget, hasMonthlyPrices, changeBudgetType }: FinanceToggleProps) => {
    const { t } = useTranslations();

    return (
        <Tooltip
            disable={hasMonthlyPrices}
            style={{ width: '1rem' }}
            handle={
                <Toggle
                    id="TESTING_JOURNEY_TYPE"
                    optionA={FINANCE}
                    optionB={CASH}
                    toggled={budget === CASH}
                    onClick={changeBudgetType}
                    disabled={!hasMonthlyPrices}
                    page="home"
                />
            }
        >
            {t('filters.button.cash.disabled1')}
            <br />
            {t('filters.button.cash.disabled2')}
            <br />
            {t('filters.button.cash.disabled3')}
        </Tooltip>
    );
};

export default FinanceToggle;
